__turbopack_context__.v({
  "description": "FeedbackDescription-module-scss-module__Mm8ulq__description",
  "error": "FeedbackDescription-module-scss-module__Mm8ulq__error",
  "fatal": "FeedbackDescription-module-scss-module__Mm8ulq__fatal",
  "icon": "FeedbackDescription-module-scss-module__Mm8ulq__icon",
  "info": "FeedbackDescription-module-scss-module__Mm8ulq__info",
  "inner": "FeedbackDescription-module-scss-module__Mm8ulq__inner",
  "is_bg": "FeedbackDescription-module-scss-module__Mm8ulq__is_bg",
  "link-icon": "FeedbackDescription-module-scss-module__Mm8ulq__link-icon",
  "success": "FeedbackDescription-module-scss-module__Mm8ulq__success",
  "text": "FeedbackDescription-module-scss-module__Mm8ulq__text",
});
